import React from 'react';
import SvgIcon from './SvgIcon';

const LaborStrike = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M14 2.938a2 2 0 11-3.07 1.609M8.92 5.601l7.085-3.717"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.249 4.9l-.355-2.379a1 1 0 01.515-1.089l1.32-.693a1 1 0 011.189.2l1.758 1.646M14.287 14.009a1.25 1.25 0 001.664.093l2.5-2a1.25 1.25 0 10-1.561-1.954l-1.627 1.3-2.208-2.206a1.251 1.251 0 00-1.768 0 1.4 1.4 0 00-.367.883v5.769a1 1 0 01-.191.588L7.16 21.39a1.25 1.25 0 102.021 1.47l2.989-4.11 2.99 4.11a1.25 1.25 0 102.021-1.47l-3.569-4.908a1 1 0 01-.192-.589v-2.75l.867.866z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.92 6.484v3.551a.5.5 0 01-.582.493L3.5 10.221a.5.5 0 01-.392-.651l1.026-3.087a.5.5 0 01.608-.324l16.178 4.466"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

LaborStrike.displayName = 'LaborStrikeIcon';

export default LaborStrike;
